<div class="layer-head">
  <div><i class="usericon icon-info-circled-alt">
  </i>&nbsp;Legende</div>
  <i for="legendcontainer" class="usericon icon-close-1 closethis hover switchbutton"></i>
</div>
